/*
 * @Description:
 * @Autor: Dai YueLin
 * @Date: 2022-07-15 13:32:18
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-07-21 15:21:41
 */
import { request } from '@/utils/request';

export function ssoLogin() {
  return request({
    url: 'login/getDIDLoginUrl',
    method: 'get',
  });
}

export function getToken(data: any) {
  return request({
    url: 'login/login',
    method: 'post',
    data,
  });
}

export function getUserInfo() {
  return request({
    url: 'auth/getUserInfo',
    method: 'get',
  });
}

export function getUserSession() {
  return request({
    url: 'auth/getUserSession',
    method: 'get',
  });
}

export function loginOut() {
  return request({
    url: 'login/loginOut',
    method: 'get',
  });
}
export function replaceToken(data: any) {
  return request({
    url: '/login/loginByChannel',
    method: 'post',
    data,
  });
}

export function getGlobalNotice() {
  return request({
    url: 'edmNotice/getGlobalNotice',
    method: 'get',
  });
}

export interface FeatureNoticeResp {
  content?: string;
  id?: number;
  isShow: number;
  noticeDate: string;
  noticeTitle: string;
  subject?: string;
}

export interface ContentsParse {
  moduleContext: string[];
  moduleName: string;
}

export interface ReadFeatureNoticeReq {
  id: number;
}

export function getFeatureNotice(): Promise<FeatureNoticeResp[]> {
  return request({
    url: 'edmNotice/getFeatureNotice',
    method: 'get',
  });
}

export function readFeatureNotice(data: ReadFeatureNoticeReq): Promise<boolean> {
  return request({
    url: `edmNotice/readFeatureNotice?id=${data.id}`,
    method: 'get',
  });
}
